import api from "api";

const paymentMethods = {
    list: () => api().get('/payment-methods'),
};

export default paymentMethods;
